module.exports = __webpack_public_path__ + "static/img/edge_shadow.02f6ecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010106/edge_shadow.png
// module id = SoMj
// module chunks = 10